import React, { useState } from 'react'
import SimpleHeader from '../layouts/SimpleHeader'
import SideMenu from '../layouts/SideMenu'
import MenuWrap from '../components/BurgerMenu/MenuWrap'
import {
  InsightLackOfInfo,
  InsightQuestions,
  InsightResponse,
} from '../components/Insights'
import { useQuery, useLazyQuery } from '@apollo/client'
import {
  GET_USERDATA_QUERY,
  MY_CAMPAIGNS_QUERY,
} from '../services/GraphQLQueries'

const Insights = () => {
  const [insightProcessType, setInsightProcessType] = useState('')
  const [queryDetails, setQueryDetails] = useState({})
  const [insightInfo, setInsightInfo] = useState({})
  const infoLimits = [1, 1, 1]
  const changeProcessType = (type, queryDetails) => {
    if (type === 'response') {
      setQueryDetails(queryDetails)
    } else {
      setQueryDetails({})
    }
    setInsightProcessType(type)
  }
  const userDataResponse = useQuery(GET_USERDATA_QUERY, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      getCampaignInfo()
    },
  })
  const [getCampaignInfo, { loading }] = useLazyQuery(
    MY_CAMPAIGNS_QUERY,
    {
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        let infoCount = {
          campaignCount: data.myCampaigns.campaignDatas.length,
          clickCount: 0,
          conversionCount: 0,
        }
        data.myCampaigns.campaignDatas.forEach((campaign) => {
          infoCount.clickCount = infoCount.clickCount + campaign.clicks
          infoCount.conversionCount =
            infoCount.conversionCount + campaign.conversions
        })
        let insightInfoTemp = {}
        if (infoCount.campaignCount < infoLimits[1]) {
          let campaignPercent = (
            (infoCount.campaignCount / infoLimits[1]) *
            0.33
          ).toString()
          insightInfoTemp.campaignStatus = 'lack'
          insightInfoTemp.campaignPercent = campaignPercent
        }
        if (infoCount.clickCount < infoLimits[1]) {
          let clickPercent = (
            (infoCount.clickCount / infoLimits[1]) *
            0.33
          ).toString()
          insightInfoTemp.clickStatus = 'lack'
          insightInfoTemp.clickPercent = clickPercent
        }
        if (infoCount.conversionCount < infoLimits[2]) {
          let conversionPercent = (
            (infoCount.conversionCount / infoLimits[2]) *
            0.33
          ).toString()
          insightInfoTemp.conversionStatus = 'lack'
          insightInfoTemp.conversionPercent = conversionPercent
        }
        if (
          Object.keys(insightInfoTemp).length !== 0 &&
          insightInfoTemp.constructor === Object
        ) {
          setInsightInfo(insightInfoTemp)
          setInsightProcessType('lackInfo')
        } else {
          setInsightProcessType('questions')
        }
      },
    }
  )
  return (
    <div id="outer-container" style={{ height: '100%' }}>
      <MenuWrap className="sm:hidden">
        <SideMenu isAuthorized={true}></SideMenu>
      </MenuWrap>
      <div id="page-wrap">
        <div className="flex">
          <SideMenu isAuthorized={true} className="hidden sm:block"></SideMenu>
          <div className="h-screen w-full">
            <SimpleHeader />
            {userDataResponse.loading || loading ? (
              <>
                <div className="loader-wrapper">
                  <div className="flex justify-center items-center">
                    <div className="grid gap-10">
                      <div className="loader"></div>
                      <div className="text-center font-unbounded">
                        Loading...
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {insightProcessType === 'lackInfo' && (
                  <InsightLackOfInfo
                    insightInfo={insightInfo}
                    infoLimits={infoLimits}
                  ></InsightLackOfInfo>
                )}
                {insightProcessType === 'questions' && (
                  <InsightQuestions
                    changeProcess={changeProcessType}
                  ></InsightQuestions>
                )}
                {insightProcessType === 'response' && (
                  <InsightResponse
                    changeProcess={changeProcessType}
                    queryDetails={queryDetails}
                  ></InsightResponse>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Insights
